var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled-1",
    transform: "translate(-3.058 -3.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M3.058,3.058h32v32h-32Z",
    transform: "translate(0 0)",
    fill: "#f0db4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M32.76,22.917c-.277-1.741-1.414-3.2-4.777-4.565-1.167-.538-2.468-.922-2.859-1.807a2,2,0,0,1-.068-1.118,1.839,1.839,0,0,1,2.417-1.037,2.659,2.659,0,0,1,1.551,1.44c1.647-1.067,1.643-1.058,2.795-1.792a7.107,7.107,0,0,0-.924-1.233,5.383,5.383,0,0,0-4.5-1.632l-1.122.145a5.121,5.121,0,0,0-2.707,1.6,5,5,0,0,0,.907,7.113c2.165,1.626,5.346,1.995,5.754,3.514.395,1.86-1.367,2.462-3.119,2.249a4.084,4.084,0,0,1-2.786-2.118c-1.429.828-1.429.828-2.9,1.673a6.454,6.454,0,0,0,1.3,1.766c2.765,2.8,9.679,2.667,10.921-1.579a5.254,5.254,0,0,0,.115-2.613ZM18.47,11.4H14.9l-.015,9.227c0,1.963.1,3.761-.218,4.311a2,2,0,0,1-2.492.74,3.057,3.057,0,0,1-1.316-1.365,1.88,1.88,0,0,0-.2-.329l-2.9,1.777a5.734,5.734,0,0,0,2.1,2.409,6.917,6.917,0,0,0,5.1.627,4.512,4.512,0,0,0,2.88-2.255c.811-1.5.638-3.311.629-5.316.019-3.273,0-6.543,0-9.824Z",
    transform: "translate(-0.825 3.042)",
    fill: "#323330"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.4a75e0b84bac782bf2463abb8bf0f705.svg";
export { ForwardRef as ReactComponent };